import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';

export default class NavBar extends React.Component { // eslint-disable-line
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
  }

  render() {
    const { children } = this.props;

    return <div className={css(styles.bodyStyle)}>{children}</div>;
  }
}

const styles = StyleSheet.create({
  bodyStyle: {
    paddingTop: 64,
    '@media (min-width: 800px)': {
      paddingLeft: 81,
    },
  },
});



// WEBPACK FOOTER //
// /src/components/Container/Body.js